import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Section } from 'tio-ui/components/layout';
import Button from 'tio-ui/components/button';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { service } from '@ember/service';
import FamilyMembersList from './family-members-list';
import InviteFamilyMemberModal from './invite-family-member-modal';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type RouterService from '@ember/routing/router-service';

interface FamilySectionSignature {
  Args: {
    employee: EmployeeModel;
  };
}

export default class FamilySection extends Component<FamilySectionSignature> {
  @tracked showInviteModal = false;
  @service declare router: RouterService;

  openInviteModal = () => {
    this.showInviteModal = true;
  };

  closeInviteModal = () => {
    this.showInviteModal = false;
  };

  handleInviteSuccess = () => {
    this.closeInviteModal();
    // Refresh the route to reload data with includes
    this.router.refresh();
  };

  get familyMemberDependents() {
    return this.args.employee.dependents.filter((d) => d.flavor === 'family_member');
  }

  <template>
    <Section>
      <:header>{{t "profile.family.section_title"}}</:header>
      <:actions>
        <Button
          @intent="primary"
          @appearance="outlined"
          @label={{t "profile.family.invite_button"}}
          {{on "click" this.openInviteModal}}
        />
      </:actions>
      <:body>
        <FamilyMembersList
          @dependents={{this.familyMemberDependents}}
          @companyName={{@employee.company.name}}
        />

        <InviteFamilyMemberModal
          @show={{this.showInviteModal}}
          @employee={{@employee}}
          @onClose={{this.closeInviteModal}}
          @onSuccess={{this.handleInviteSuccess}}
        />
      </:body>
    </Section>
  </template>
}
